import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c40f28d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-topbar" }
const _hoisted_2 = { class: "oxd-topbar-header-title" }
const _hoisted_3 = { class: "oxd-topbar-header-breadcrumb" }
const _hoisted_4 = { class: "oxd-topbar-header-userarea" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon = _resolveComponent("oxd-icon")!
  const _component_oxd_text = _resolveComponent("oxd-text")!
  const _component_oxd_user_dropdown = _resolveComponent("oxd-user-dropdown")!
  const _component_oxd_navigation = _resolveComponent("oxd-navigation")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.headerClasses)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_oxd_icon, {
          name: "list",
          class: "oxd-topbar-header-hamburger",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('collapse')))
        }),
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_oxd_text, {
            tag: "h6",
            class: "oxd-topbar-header-breadcrumb-module"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.breadcrumb.moduleName), 1)
            ]),
            _: 1
          }),
          (_ctx.breadcrumb.level)
            ? (_openBlock(), _createBlock(_component_oxd_text, {
                key: 0,
                tag: "h6",
                class: "oxd-topbar-header-breadcrumb-level"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.breadcrumb.level), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", null, [
          _createVNode(_component_oxd_user_dropdown, { user: _ctx.user }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]),
            _: 3
          }, 8, ["user"])
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.bodyClasses)
    }, [
      _createVNode(_component_oxd_navigation, { "menu-items": _ctx.menuItems }, null, 8, ["menu-items"])
    ], 2)
  ]))
}